<template>
  <div>
    <base-material-card color="#1e293b" class="px-5 py-3">
      <template v-slot:heading>
        <div class="font-weight-light">วิทยาลัย</div>

        <h2 class="font-weight-light">ข้อมูลวิทยาลัยที่อยู่ในระบบ</h2>
      </template>

      <v-card-text>
        <v-data-table :headers="headers" :items="colleges" :search="search">
          <template v-slot:top>
            <v-row no-gutters align="center" class="px-4 pt-2">
              <v-col cols="12" sm="8">
                <v-text-field
                  v-model="search"
                  label="ค้นหา :"
                  class="mr-4"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="text-sm-right">
                <v-btn outlined color="#1e293b" @click="exportData">
                  <v-icon left small>mdi-file-excel</v-icon>
                  ส่งออกข้อมูล
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </base-material-card>
  </div>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "HRvecReportCollege",

  data() {
    return {
      ApiKey: "HRvec2021",
      headers: [
        { text: "ชื่อวิทยาลัย", align: "left", value: "college_name" },
        { text: "อำเภอ", align: "left", value: "prefecture_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ประเภทวิทยาลัย", align: "left", value: "collegetype_name" },
        { text: "ประเภทอัตรากำลัง", align: "left", value: "name_ctm" },
        { text: "สถาบันการอาชีวศึกษา", align: "left", value: "veiVocalName" },
        { text: "เบอร์โทร", align: "left", value: "collegeinfo_phone" }
      ],
      colleges: [],
      search:'',
    };
  },

  async mounted() {
    await this.collegeQuery();
  },

  methods: {
    async collegeQuery() {
      let result;
      result = await this.$http.post("college.php", {
        ApiKey: this.ApiKey
      });
      this.colleges = result.data;
    },

    exportData() {
      try {
        const exportRows = this.colleges.map(item => ({
          'ชื่อวิทยาลัย': item.college_name,
          'อำเภอ': item.prefecture_name,
          'จังหวัด': item.province_name,
          'ประเภทวิทยาลัย': item.collegetype_name,
          'ประเภทอัตรากำลัง': item.name_ctm,
          'สถาบันการอาชีวศึกษา': item.veiVocalName,
          'เบอร์โทร': item.collegeinfo_phone
        }));

        const ws = XLSX.utils.json_to_sheet(exportRows);
        ws["!cols"] = [{ wch: 30 }, { wch: 16 }, { wch: 16 }, { wch: 20 }, { wch: 20 }, { wch: 24 }, { wch: 16 }];

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "วิทยาลัย");

        const dateStr = new Date().toISOString().split('T')[0];
        XLSX.writeFile(wb, `ข้อมูลวิทยาลัย_${dateStr}.xlsx`);
      } catch (error) {
        console.error('Export error:', error);
      }
    }
  }
};
</script>
